export const EVENT_STATUS = {
	INACTIVE: 'INACTIVE',
	ACTIVE: 'ACTIVE',
};

export const SINGLE_PAGE_APP = {
	TRUE: 'TRUE',
	FALSE: 'FALSE',
};

export const ANONYMOUS_LOGIN = {
	TRUE: 'TRUE',
	FALSE: 'FALSE',
};

export const TIMEZONE_DISPLAY = {
	LOCAL: 'LOCAL',
	EVENT: 'EVENT',
};

// EVENT is the backend column default, so anything but an explicit LOCAL is event time.
export const isEventTimezoneDisplay = timezoneDisplay => timezoneDisplay !== TIMEZONE_DISPLAY.LOCAL;

export const ACTIVE_HOMESCREEN = {
	STANDARD: 'STANDARD',
	WIDGET: 'WIDGET',
};

export const AGENDA_RANGE = {
	FULL: 'full',
	TODAY: 'today',
};

export const RECURRING_TIME_TYPE = {
	NOT_RECURRING: 'NOT_RECURRING',
	DAILY: 'DAILY',
	WEEKLY: 'WEEKLY',
	MONTHLY: 'MONTHLY',
	YEARLY: 'YEARLY',
	HOURLY: 'HOURLY',
};

// Stands in for a page id in the room key for the two event-level routes with no page in the URL:
// `widgetHome` (the homescreen widget builder) and `home` (edits homescreen_layout, but subscribes too).
export const HOMESCREEN_PAGE_ID = 'home';

// Single derivation of that room key. Subscribers pass the route param and emitters pass page.id —
// the same value one hop apart — so normalizing here keeps a string and a number from splitting rooms.
export const widgetRoomPageId = pageId =>
	pageId === undefined || pageId === null ? HOMESCREEN_PAGE_ID : String(pageId);

export const EVENT_ADMIN_CONTRIBUTOR_TYPES = {
	AGENDA: 'Agenda',
	ANALYTICS: 'Analytics Report',
	APP_DESIGN: 'App Layout / Content',
	ATTENDEES: 'People / Groups',
	ANNOUNCEMENTS: 'Push Announcements',
	SOCIAL_FEED: 'Social Engagement',
	PLUGINS: 'Live Features',
};
